import {useRadarLocale} from '@/i18n/RadarLocaleContext';
export function RadarBriefBadge({version}:{version?:number|null}) {
 const {t}=useRadarLocale();
 return <small><span className="radar-brief-version" title={t('Brief used when this company was first discovered')}>{version?t('First found · v{version}',{version}):t('Historical source')}</span></small>;
}
